module.exports = __webpack_public_path__ + "static/wireframe2-2fe7ffa7a51d4c54f910ebf2f891628d.png";